module.exports = __webpack_public_path__ + "img/23_83.ea5a3d35.png";